import { PropsWithChildren, ReactNode } from 'react';

import { Card } from '@strategyProfile/components/StrategyPageMain/Components/Card';
import { RowsSeparator } from '@strategyProfile/components/StrategyPageMain/Components/RowsSeparator';
import { useTranslations } from 'next-intl';

import { PublicStrategy } from '@/api/copy-trading/types';
import { WithTrendColor } from '@/blocks/components/WithTrendColor';
import { FormatPercent } from '@/blocks/formatters';
import typography from '@/styles/typography.module.scss';

import styles from './styles.module.scss';

function Field({ name, value }: { name: ReactNode; value: React.ReactNode }) {
  return (
    <li className={styles.field}>
      <div className={typography.bodyS}>{name}</div>
      <div className={typography.bodyM}>{value}</div>
    </li>
  );
}

export function PerformancePanel({ strategy }: { strategy: PublicStrategy }) {
  const tr = useTranslations();
  return (
    <Card
      title={tr.rich('pages.strategyPage.sections.main.widgets.performance.title')}
      innerContentMaxWidthDesktop={328}
    >
      <ul className={styles.perfomancePanel}>
        <Field
          name={tr.rich('pages.strategyPage.sections.main.widgets.performance.fields.profit')}
          value={
            <WithTrendColor negative={strategy.indicators.profit < 0}>
              <FormatPercent forcePlusSign value={strategy.indicators.profit} />
            </WithTrendColor>
          }
        />
        {strategy.indicators.profit30Days ? (
          <Field
            name={tr.rich('pages.strategyPage.sections.main.widgets.performance.fields.profit30d')}
            value={
              <WithTrendColor negative={strategy.indicators.profit30Days < 0}>
                <FormatPercent forcePlusSign value={strategy.indicators.profit30Days} />
              </WithTrendColor>
            }
          />
        ) : null}
        <Field
          name={tr.rich('pages.strategyPage.sections.main.widgets.performance.fields.winRatio')}
          value={
            <WithTrendColor negative={strategy.indicators.winRatio < 0}>
              <FormatPercent forcePlusSign value={strategy.indicators.winRatio} />
            </WithTrendColor>
          }
        />
        <Field
          name={tr.rich('pages.strategyPage.sections.main.widgets.performance.fields.winRatio30d')}
          value={
            <WithTrendColor negative={strategy.indicators.winRatio30Days < 0}>
              <FormatPercent forcePlusSign value={strategy.indicators.winRatio30Days} />
            </WithTrendColor>
          }
        />
        <Field
          name={tr.rich('pages.strategyPage.sections.main.widgets.performance.fields.maxDrawdown')}
          value={<FormatPercent value={strategy.indicators.maxDrawdown} />}
        />
        <Field
          name={tr.rich('pages.strategyPage.sections.main.widgets.performance.fields.maxDrawdown30d')}
          value={<FormatPercent value={strategy.indicators.maxDrawdown30Days} />}
        />
      </ul>
    </Card>
  );
}
